
import React, { useEffect } from 'react';
import { SkinAnalysisSection } from '@/components/ai-assistance/SkinAnalysisSection';
import { EnhancedChatWindow } from '@/components/ai-assistance/EnhancedChatWindow';
import { TokenBalance } from '@/components/tokens/TokenBalance';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

const MobileAiAssistanceSection = () => {
  // Initialize storage buckets as soon as component mounts
  useEffect(() => {
    const initStorage = async () => {
      try {
        console.log("Initializing storage buckets for mobile");
        const response = await supabase.functions.invoke('create-storage-buckets');
        
        if (response.error) {
          console.error("Error initializing storage buckets:", response.error);
          toast.error("Erreur d'initialisation", {
            description: "Impossible d'initialiser le stockage des images. Certaines fonctionnalités peuvent ne pas fonctionner correctement.",
          });
        } else {
          console.log("Storage buckets initialized successfully:", response.data);
        }
      } catch (error) {
        console.error("Error initializing storage buckets:", error);
        toast.error("Erreur d'initialisation", {
          description: "Une erreur s'est produite lors de l'initialisation du stockage.",
        });
      }
    };
    
    initStorage();
  }, []);

  return (
    <div className="space-y-6 pb-20">
      {/* Token Balance for mobile */}
      <TokenBalance showDonationButton={true} />
      
      <SkinAnalysisSection />
      
      <div className="glass-morphism rounded-lg overflow-hidden shadow-md">
        <EnhancedChatWindow />
      </div>
    </div>
  );
};

export default MobileAiAssistanceSection;
